import React from "react";

import { NewModuleDisplay } from "@components";
import { Layout } from "./PageLayouts";

/**
 * A page to display the various points at which to start a new module.
 */
export function NewModulePage() {
  return (
    <Layout>
      <NewModuleDisplay />
    </Layout>
  );
}
